import React from 'react';
import './Toast.scss';

/**
 * Fixed top-right toast notification.
 *
 * Props:
 *   message  — text to display
 *   visible  — boolean (controlled by parent)
 *   type     — 'success' | 'error' | 'info'  (default: 'success')
 */
export default function Toast({ message, visible, type = 'success' }) {
  if (!visible || !message) return null;
  return (
    <div className={`toast toast-${type}`}>
      {message}
    </div>
  );
}
